export const COLORS = {
  cellGrey: "#CCCCCC",
  lightGrey: "#979F9E",
  darkGrey: "#676F6E",
  mediumGrey: "#A6A6A6",
  offWhite: "#FAFAFA",
  paleGrey: "#EEEEEE",
  red: "#E61F2A",
  primary: "rgb(230, 30, 41)",
  secondary: "rgb(0, 86, 172)",
  unacceptable: "#f0261f",
  tolerable: "#E77E2E",
  acceptable: "#6CA956",
};

export const RISK_RATING_COLOR_LABELS = {
  "#240505": "WOOD_BARK",
  "#4D0F65": "JAGGER",
  "#880E0E": "TAMARILLO",
  "#E51A1A": "ALIZARIN_CRIMSON",
  "#E77E2F": "ZEST",
  "#FFDA47": "BRIGHT_SUN",
  "#BDD372": "WILD_WILLOW",
  "#66A74F": "CHELSEA_CUCUMBER",
  "#59DBF2": "SPRAY",
  "#B3B3B3": "NOBEL",
  "#9E9E9E": "SILVER_CHALICE",
  "#A6F7FF": "LIGHT_ANAKIWA",
  "#8CEEFB": "ANAKIWA",
};
